<template>
  <div>
    <a-linechart :height="height" :series="series" :xaxis="xaxis" />
    <v-overlay :absolute="true" :value="isLoading" opacity="0.2" z-index="1">
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import lineChart from "@/components/charts/line";
import services from "@/services/index.js";

export default {
  props: ["height", "course"],
  components: {
    "a-linechart": lineChart
  },
  data: () => ({
    isLoading: false,
    series: [],
    xaxis: []
  }),
  methods: {
    compileSeries(series, name, type = "line") {
      let compiledSeries = {
        name: name,
        data: [],
        type
      };

      let currMonth = new Date().getUTCMonth() + 1;
      let months = [];
      for (var i = 1; i <= 12; i++) {
        let pushed = false;
        series.forEach(data => {
          if (data.month == currMonth) {
            compiledSeries.data.push(data.total);
            months.push(currMonth);
            pushed = true;
          }
        });
        if (pushed == false) {
          compiledSeries.data.push(0);
          months.push(currMonth);
        }
        currMonth--;
        if (currMonth < 1) {
          currMonth = 12;
        }
      }
      this.xaxis = months
        .map(obj => {
          return [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ][obj - 1];
        })
        .reverse();
      compiledSeries.data.reverse();
      return compiledSeries;
    },
    async onLoad() {
      this.isLoading = true;
      try {
        let data = null;
        if (!this.course) {
          data = await services.metrics.get();
        } else {
          data = await services.metrics.get({ course: this.course });
        }
        if (
          !data.series ||
          !data.series.enrollment ||
          !Array.isArray(data.series.enrollment)
        ) {
          return;
        }
        this.series = [
          this.compileSeries(data.series.activation, "Activation", "line"),
          this.compileSeries(data.series.enrollment, "Enrollment"),
          this.compileSeries(data.series.completed, "Completed"),
          this.compileSeries(data.series.dropped, "Dropped")
        ];
      } catch (err) {
        this.isLoading = false;
      }
      this.isLoading = false;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
